import { Link } from "react-router-dom";
import { genres } from "@/mocks/genres";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-950 mt-16">
      <div className="px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-xl text-background-50"></i>
              </span>
              <span className="text-background-50 font-heading font-black text-lg">最新电影</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              汇聚最新上映影片资讯、评分介绍与影院上映动态，帮你更快找到值得走进影院的那部电影。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">站内导航</h2>
            <ul className="space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/category/action", label: "全部影片" },
                { to: "/cinema", label: "影院动态" },
                { to: "/search", label: "搜索电影" },
                { to: "/about", label: "关于我们" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">热门类型</h2>
            <ul className="grid grid-cols-2 gap-y-2.5 gap-x-3 text-sm">
              {genres.slice(0, 8).map((g) => (
                <li key={g.slug}>
                  <Link to={`/category/${g.slug}`} className="text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                    {g.label}片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-background-50 font-semibold text-sm mb-4 tracking-wide">联系我们</h2>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-lg text-accent-400 mt-0.5"></i>
                <span>feedback@latestmovie.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-lg text-accent-400 mt-0.5"></i>
                <span>内容每日更新，每周发布上映动态</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line text-lg text-accent-400 mt-0.5"></i>
                <span>站内影片信息均为演示内容</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {year} 最新电影 Latest Movies · 本网站为影视资讯演示站点，所有影片信息与评分为虚构示例。
          </p>
          <p className="text-xs text-background-400">
            本站不提供在线购票及票务服务，影院信息仅作展示参考。
          </p>
        </div>
      </div>
    </footer>
  );
}